// Прогресс ребёнка (К-13, FR-PROF-02): статусы принципов по тем же правилам, что на сервере.
import { TopBar } from "../components/Shell.tsx";
import { activeChild, useApp } from "../state/app.ts";
import { t } from "../i18n/ru.ts";

export function Progress() {
  const { statuses, content, lastSyncAt } = useApp();
  const child = activeChild();
  const st = child ? statuses[child.id] ?? {} : {};
  const principles = content?.dictionaries.principles ?? {};
  const order = ["mastered", "progressing", "introducing", "not_started"];
  const rows = Object.entries(st).sort((a, b) => order.indexOf(a[1].status) - order.indexOf(b[1].status));
  return (
    <div className="page">
      <TopBar title={child ? `${t.progress.title}: ${child.nickname}` : t.progress.title} />
      {!rows.length ? <p className="muted">{t.progress.empty}</p> : null}
      <ul className="progress-list">
        {rows.map(([code, s]) => (
          <li key={code} className="card">
            <span className={`badge badge--${s.status}`}>{t.progress.statuses[s.status]}</span>
            <div>
              <strong>{principles[code]?.name ?? code}</strong>
              <p className="muted small">
                «{principles[code]?.kid}» · {t.progress.answers(s.first_attempts)}
              </p>
            </div>
          </li>
        ))}
      </ul>
      <p className="muted small">{lastSyncAt ? t.progress.synced(new Date(lastSyncAt).toLocaleString("ru-RU")) : t.progress.notSynced}</p>
    </div>
  );
}
